module.exports = __webpack_public_path__ + "img/23-l.f666cff5.png";